/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import { URL_MENTIONS } from '@/constants';
import type { CleMentionActe } from '@/types';

import MentionListe from './MentionListe';

interface MentionListeContainerProps {
  /**
   * Colonne de rattachement à l'acte, selon son type : la même liste sert la
   * fiche de naissance comme celle de reconnaissance.
   */
  cleActe: CleMentionActe;
  identifiantActe?: number;
  /** Ouvre automatiquement la modale « Ajouter une mention » au montage. */
  autoOpenAjoutMention?: boolean;
}

const MentionListeContainer = (props: MentionListeContainerProps) => {
  const { cleActe, identifiantActe, autoOpenAjoutMention } = props;

  const defaultFilters = {
    ...(identifiantActe && { [cleActe]: identifiantActe }),
  };

  const [serviceListe] = useListe(URL_MENTIONS, defaultFilters);

  return (
    <ListeContainer
      type="mentions"
      contains="liste"
      service={serviceListe}
      perPage={20}
    >
      <MentionListe
        cleActe={cleActe}
        identifiantActe={identifiantActe}
        autoOpenAjoutMention={autoOpenAjoutMention}
      />
    </ListeContainer>
  );
};

export default MentionListeContainer;
